import { lastValueFrom, Observable } from 'rxjs';

interface RxjsHttpResponseWithJsonBody {
  status: number;
  clone(): { json(): Observable<unknown> };
}

export interface RxjsHttpErrorResponseBody {
  code?: string;
  error?: {
    code?: number | string;
    message?: string;
  };
  message?: string;
  status?: string;
}

function getRxjsHttpResponseWithJsonBody(error: unknown): RxjsHttpResponseWithJsonBody | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    'clone' in error &&
    typeof (error as { clone: unknown }).clone === 'function'
  ) {
    return error as RxjsHttpResponseWithJsonBody;
  }

  return null;
}

export async function getRxjsHttpErrorResponseBody(error: unknown): Promise<RxjsHttpErrorResponseBody | null> {
  const httpError = getRxjsHttpResponseWithJsonBody(error);

  if (httpError === null) {
    return null;
  }

  try {
    return (await lastValueFrom(httpError.clone().json())) as RxjsHttpErrorResponseBody;
  } catch {
    return null;
  }
}

export function getRxjsHttpErrorStatus(error: unknown): number | null {
  return getRxjsHttpResponseWithJsonBody(error)?.status ?? null;
}

export function getRxjsHttpErrorCode(responseBody: RxjsHttpErrorResponseBody | null): string | undefined {
  return responseBody?.error?.message ?? responseBody?.code ?? responseBody?.message;
}
